import { Customer } from 'data/firestore/agent/customer/types';
import { EntityGet } from 'data/firestore/types';
import { createContext } from 'react';

export interface Context {
    customer?: EntityGet<Customer> | null;
    isLoading?: boolean;
}

const context = createContext<Context>({
    isLoading: false,
});

export const { Provider, Consumer } = context;

export default context;
